import { Format } from "./format"
import { Margins } from "./margins"

/**
 * @memberOf Tee.Chart
 * @constructor
 * @public
 * @class Defines the visual properties for chart background
 * @param {Tee.Chart} chart The parent chart this panel object belongs to.
 * @property {Tee.Margins} margins Controls the spacing between background panel to chart contents.
 * @property {Format} format Visual properties to paint the chart panel background.
 * @property {Boolean} transparent Determines if panel background will be filled or not.
 */
export function Panel(chart) {
	var f = (this.format = new Format(chart))
	f.round.x = 12
	f.round.y = 12
	f.stroke.size = 3
	f.gradient.visible = true
	f.gradient.direction = "bottomtop"
	f.shadow.visible = true
	f.stroke.fill = "#606060"

	this.transparent = !!chart.__webgl

	this.margins = new Margins()

	this.clear = () => {
		var b = chart.bounds
		chart.ctx.clearRect(b.x, b.y, b.width, b.height)
	}

	this.draw = function () {
		if (this.transparent || chart.__webgl) this.clear()
		else {
			var r = chart.chartRect,
				sh = f.shadow

			if (sh.visible) {
				r.width -= 0.5 * Math.abs(sh.width) + 2
				r.height -= 0.5 * Math.abs(sh.height) + 2

				if (sh.width < 0) r.x -= sh.width
				if (sh.height < 0) r.y -= sh.height
			}

			var s = 0

			if (f.stroke.fill !== "") {
				s = f.stroke.size
				if (s > 1) {
					s *= 0.5
					r.x += s
					r.y += s
					r.width -= 2 * s
					r.height -= 2 * s
				}
			}

			if (sh.visible || f.round.x > 0 || f.round.y > 0) this.clear()

			f.rectangle(r)

			if (s > 0) {
				r.x += s
				r.y += s
				r.width -= 2 * s
				r.height -= 2 * s
			}
		}
	}
}
